import React, { useState } from 'react';
import CodeBlock from "@components/codeblock"

const options = [
    {
      value: 'primary',
      label: 'Primary',
      codeField:`<button type="button" class="button primary">Shop Now</button>`,
      modifiers: [
        {
          primary: `<button type="button" class="button primary">Shop Now</button>`,
          success: `<button type="button" class="button primary success">Shop Now</button>`,
          disabled: `<button type="button" class="button primary disabled">Disabled</button>`,
          loading: `<button type="button" class="button primary loading"><div><span>&bull;</span><span>&bull;</span><span>&bull;</span></div></button>`,
          error: `<button type="button" class="button primary error">Not Found</button>`,
        },
      ],
      css: `
      <style type="text/css"><!-- #include virtual="/common/nebula/components/button/master.css"--></style>
      <style type="text/css"><!-- #include virtual="/common/nebula/components/button/primary.css"--></style>`,
    },   
    {
      value: 'secondary',
      label: 'Secondary',
      codeField:`<button type="button" class="button secondary">Edit Details</button>`,
      modifiers: [
        {
          disabled: `<button type="button" class="button secondary disabled">Disabled</button>`,
          error: `<button type="button" class="button secondary error">Not Found</button>`,
        },
      ],
      css: `
      <style type="text/css"><!-- #include virtual="/common/nebula/components/button/master.css"--></style>
      <style type="text/css"><!-- #include virtual="/common/nebula/components/button/secondary.css"--></style>`,
    },  
    {
      value: 'tertiary',
      label: 'Tertiary',
      codeField:`<button type="button" class="button tertiary">Edit Details</button>`,
      modifiers: [
        {
          disabled: `<button type="button" class="button tertiary disabled">Disabled</button>`,
          error: `<button type="button" class="button tertiary error">Not Found</button>`,
        },
      ],
      css: `
      <style type="text/css"><!-- #include virtual="/common/nebula/components/button/master.css"--></style>
      <style type="text/css"><!-- #include virtual="/common/nebula/components/button/tertiary.css"--></style>`,
    },  
  ];


function ButtonStates() {
  const defaultSate = options[0].codeField
  const defaultCSS = options[0].css
  const defaultModifiers = options[0].modifiers

   
    return (
    <>

        <CodeBlock  value={defaultSate}
                    codeProv={true}
                    options={options}
                    defaultSate={defaultSate}
                    defaultCSS={defaultCSS}
                    defaultModifiers={defaultModifiers}
                    />
    </>
    );
    }

export default ButtonStates